module.exports = __webpack_public_path__ + "img/avatar_7.71f10e3c.jpg";